export function scrollSync($container1: HTMLElement, $container2: HTMLElement) {
  const $sync1 = $container1;
  const $sync2 = $container2;

  let leftScrollFlag = false;
  let rightScrollFlag = false;

  const outputScroll = () => {
    const scrollPercent = $sync1.scrollTop / $sync1.scrollHeight;
    if (!leftScrollFlag) {
      $sync2.scrollTop = Math.round(scrollPercent * $sync2.scrollHeight);
      rightScrollFlag = true;
    }
    leftScrollFlag = false;
  };
  const inputScroll = () => {
    const scrollPercent = $sync2.scrollTop / $sync2.scrollHeight;
    if (!rightScrollFlag) {
      $sync1.scrollTop = Math.round(scrollPercent * $sync1.scrollHeight);
      leftScrollFlag = true;
    }
    rightScrollFlag = false;
  };

  $sync2.addEventListener("scroll", inputScroll);
  $sync1.addEventListener("scroll", outputScroll);
}



// WEBPACK FOOTER //
// ../~/tslint-loader!./scripts/utils/scroll-sync.ts